import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["tab"];

    toggle(event) {
        this.tabTargets.forEach(tab => {
            if (tab === event.target) {
                tab.classList.add("active");
                tab.classList.replace("yellow-text", "light-orange")
            } else {
                tab.classList.remove("active");
                tab.classList.replace("light-orange", "yellow-text")
            }
        });
    }
}